import { render } from "./Authentication.vue?vue&type=template&id=8994c4c2"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Authentication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8994c4c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8994c4c2', __exports__)) {
    api.reload('8994c4c2', __exports__)
  }
  
  module.hot.accept("./Authentication.vue?vue&type=template&id=8994c4c2", () => {
    api.rerender('8994c4c2', render)
  })

}


export default __exports__